import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Eleve } from '@app/models/enseignant';
import { FamilyService, UserService } from '@app/services';
import { EnseignantService } from '@app/services/enseignant.service';

@Component({
  selector: 'app-enseignant-eleves',
  standalone: false,
  templateUrl: './enseignant-eleves.component.html',
  styleUrl: './enseignant-eleves.component.scss'
})
export class EnseignantElevesComponent implements OnInit {
  enseignantService = inject(EnseignantService);
  userService = inject(UserService);
  dialog = inject(MatDialog);
  familyService = inject(FamilyService);

  idEnseignant: number;
  isLoading = signal(true);
  searchSignal = signal('');
  elevesSignal = signal<Eleve[]>([]);

  filteredEleves = computed(() => {
    const search = this.searchSignal().toLowerCase();
    return this.elevesSignal().filter(eleve =>
      eleve.nomReferent?.toLowerCase().includes(search)
    );
  });

  ngOnInit(): void {
    this.idEnseignant = this.userService.currentUser.idEnseignant;
    this.enseignantService.getInscriptionsByIdEnseignant(this.idEnseignant).subscribe(eleves => {
      eleves.sort((a, b) => a.nomReferent.localeCompare(b.nomReferent));
      this.elevesSignal.set(eleves);
      this.isLoading.set(false);
    })
  }
}
